import { useState } from "react";
import axios from "axios";

function useUpdatePlayer() {
  const [loadingPlayer, setLoading] = useState(false);

  const updatePlayer = async (id, playerData) => {
    try {
      setLoading(true);
      const BEARER_TOKEN = "Bearer " + window.localStorage.getItem("jwt");
      const GET_PLAYER_URL = process.env.REACT_APP_URL_API + "/players/" + id;
      const playerResponse = await axios.put(GET_PLAYER_URL, playerData, {
        headers: { Authorization: BEARER_TOKEN },
      });
      return playerResponse?.data;
    } catch (e) {
      console.log(e?.response);
      return e?.response;
    } finally {
      setLoading(false);
    }
  };

  return { loadingPlayer, updatePlayer };
}

export default useUpdatePlayer;
